import type { Identifier } from "ra-core";

import { cn } from "@/lib/utils";

// Fixed order per agent id, so a person keeps their color everywhere
const AGENT_COLORS = [
  "bg-violet-100 text-violet-800 dark:bg-violet-900/50 dark:text-violet-200",
  "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/50 dark:text-emerald-200",
  "bg-amber-100 text-amber-800 dark:bg-amber-900/50 dark:text-amber-200",
  "bg-sky-100 text-sky-800 dark:bg-sky-900/50 dark:text-sky-200",
  "bg-rose-100 text-rose-800 dark:bg-rose-900/50 dark:text-rose-200",
];

const agentColor = (id: Identifier): string =>
  AGENT_COLORS[(Number(id) - 1 + AGENT_COLORS.length) % AGENT_COLORS.length];

/** Small rounded chip with the agent's name (or initial when compact). */
export const AgentChip = ({
  id,
  name,
  compact = false,
  className,
}: {
  id: Identifier;
  name: string;
  compact?: boolean;
  className?: string;
}) => (
  <span
    title={name}
    className={cn(
      "inline-flex items-center justify-center rounded-full text-xs font-medium",
      compact ? "h-6 w-6" : "px-2 py-0.5",
      agentColor(id),
      className,
    )}
  >
    {compact ? name.charAt(0).toUpperCase() : name}
  </span>
);
